/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { RedisCacheDto } from '../models/redis-cache-dto';

@Injectable({
  providedIn: 'root',
})
export class RedisCacheControllerService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getRedisRefreshRecords
   */
  static readonly GetRedisRefreshRecordsPath = '/api/v1/cacheRefresh';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getRedisRefreshRecords()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRedisRefreshRecords$Response(params?: {
  }): Observable<StrictHttpResponse<Array<RedisCacheDto>>> {

    const rb = new RequestBuilder(this.rootUrl, RedisCacheControllerService.GetRedisRefreshRecordsPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<RedisCacheDto>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getRedisRefreshRecords$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRedisRefreshRecords(params?: {
  }): Observable<Array<RedisCacheDto>> {

    return this.getRedisRefreshRecords$Response(params).pipe(
      map((r: StrictHttpResponse<Array<RedisCacheDto>>) => r.body as Array<RedisCacheDto>)
    );
  }

}
